<template>
    <div>
        <h3 class="big-title">信息发布>></h3>
        <ul class="info-ul">
            <li class="list" :key="m.id" v-for="(m, index) in list">
                <router-link :to="{path: '/infodes', query:{id:m.id}}">
                    <h3>{{m.title}}</h3>
                    <p class="ellipsis-3 des">{{clearHtml(m.content)}}</p>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex';
    export default {
        components: {},
        data() {
            return {
                list: []
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
            this.getData();
        },
        methods: {
            // ...mapMutations([])
            async getData() {
                let {
                    data
                } = await this.$y_ajax('api/help/question', {
                    cid: 8
                })
                let obj = {};
                data.forEach((v) => {
                    obj[v.id] = v
                });
                this.$y_setKey('queList', obj)
                this.list = data
            }
        },
        computed: {
            // 计算属性
            // ...mapGetters([])
        },
        watch: {
            // 监听
        }
    };
</script>

<style lang="less" scoped>
    .info-ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .list {
        padding: 20px;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        width: 48%;

        .des {
            margin-top: 10px;
            color: #757575;
            line-height: 1.5;
        }
    }
</style>